import React from 'react';
import { Section } from './ui/Section';
export function EmotionalIntro() {
  return <Section className="border-b border-black" data-id="element-2">
      <div className="prose prose-xl md:prose-2xl max-w-none text-black" data-id="element-3">
        <p className="font-serif text-3xl md:text-4xl leading-tight mb-12 font-bold" data-id="element-4">
          Hay un punto donde ya no te falta información.{' '}
          <span className="bg-yellow-300 px-1" data-id="element-5">
            Te falta un sistema que no te obligue a mentirte todos los días.
          </span>
        </p>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-6">
          <div data-id="element-7">
            <p className="mb-6 text-gray-800" data-id="element-8">
              Porque eso es lo que pasa cuando "haces lo correcto" y aun así:
            </p>
            <ul className="space-y-4 font-bold text-lg md:text-xl list-none pl-0 mb-8" data-id="element-9">
              <li className="flex items-center border-b border-gray-200 pb-2" data-id="element-10">
                – Tu cuenta sigue en ceros
              </li>
              <li className="flex items-center border-b border-gray-200 pb-2" data-id="element-11">
                – Tus deudas no bajan
              </li>
              <li className="flex items-center border-b border-gray-200 pb-2" data-id="element-12">
                – Tu salario no sube
              </li>
              <li className="flex items-center border-b border-gray-200 pb-2" data-id="element-13">
                – Tu ansiedad financiera sube
              </li>
              <li className="flex items-center border-b border-gray-200 pb-2 text-red-600" data-id="element-14">
                – Tu futuro se ve igual de negro
              </li>
            </ul>
          </div>

          <div className="bg-gray-100 p-8 border-l-8 border-black" data-id="element-15">
            <p className="text-xl md:text-2xl font-bold mb-4" data-id="element-16">
              No porque seas estúpido.
            </p>
            <p className="text-lg text-gray-700" data-id="element-17">
              Sino porque tu rutina está diseñada para sobrevivir, no para
              progresar. Y cuando un hombre vive en modo supervivencia, hace lo
              que está programado para hacer:{' '}
              <strong className="text-black" data-id="element-18">
                buscar escapes, perseguir dinero fácil y evitar el rechazo.
              </strong>
            </p>
          </div>
        </div>
      </div>
    </Section>;
}